import React from "react";

const RefundPolicyComponent = () => {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: "1440px",
        minHeight: "100vh",
        background: "linear-gradient(172.67deg, #fffbf9 5.7%, #f7ece3 60.35%)",
        display: "flex",
        flexDirection: "column",
        margin: "0 auto",
      }}
    >
      <div
        style={{
          maxWidth: "1440px",
          margin: "0 auto",
          padding: "30px 60px",
        }}
      >
        <h1
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            marginBottom: "24px",
            color: "#333",
          }}
        >
          Refund & Cancellation Policy
        </h1>

        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          Thank you for registering for the CREDTECH Knowledge Platform. We appreciate your participation and look forward to hosting you at our event. Please review the following policy regarding cancellations and refunds.
        </p>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          1. General Policy
        </h2>
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          No Refunds: Once a ticket or pass has been purchased, it is non-refundable under any circumstances. This includes situations such as change in personal plans, travel delays, or inability to attend the event.
        </p>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          2. Duplicate or Erroneous Payments
        </h2>
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          In the event of a duplicate payment, please notify us immediately at{" "}
          <a
            href="mailto:info@cred-tech.org"
            style={{ color: "#2563eb", textDecoration: "underline" }}
          >
            info@cred-tech.org
          </a>
          . Upon verification, the excess amount will be refunded to the original payment method within 7–10 business days.
        </p>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          3. Event Postponement or Cancellation
        </h2>
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          If the event is cancelled by the organizers, a full refund will be issued to registered participants.
          If the event is postponed, registrations will be automatically transferred to the rescheduled date. No refunds will be processed in this case.
        </p>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          4. Processing Time
        </h2>
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          Approved refunds (for duplicate payments or organizer-led cancellations) will be processed within 7–10 business days after verification.
        </p>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          5. Policy Updates
        </h2>
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          The organizers reserve the right to amend this policy at any time. Any updates will be published on the official event communication channels and will apply to future registrations from the date of posting.
        </p>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          6. Contact Information
        </h2>
        <p style={{ lineHeight: "1.6", color: "#555" }}>
          For any queries or refund-related requests, please contact:<br />
          CREDTECH Knowledge Platform Support Team<br />
          <a
            href="mailto:info@cred-tech.org"
            style={{ color: "#2563eb", textDecoration: "underline" }}
          >
            info@cred-tech.org
          </a>
        </p>
      </div>
    </div>
  );
};

export default RefundPolicyComponent;